module.exports = __webpack_public_path__ + "static/media/CatTop.959d7051.svg";